/* Timber custom: product description sections (July 2026). Merchant
   descriptions follow a loose authoring pattern — bold-only paragraphs as
   pseudo-headings ("Description", "Shipping") mixed with real h3/h4
   headings ("Features", "Compatibility") and bullet lists everywhere. This
   normalizes them into one system: pseudo-headings become real h4s, each
   heading starts a hairline-separated .pdesc-section, and logistics
   sections (shipping / warranty / returns) get a --specs class so their
   lists render as quiet spec rows instead of check items (styles in
   section-main-product.css). Safe on any description shape; without JS the
   check-list styling still applies. */
(function () {
  var desc = document.querySelector('.product__description');
  if (!desc || desc.dataset.pdescDone) return;
  desc.dataset.pdescDone = 'true';

  /* Google-Sheets paste noise: inline spans carrying their own font size or
     family (e.g. style="font-size: 0.875rem" — 8.75px under Dawn's 62.5%
     root) render single sentences tiny and off-font next to the rest of the
     copy. Strip just those two properties so the text rejoins the
     description scale; links and intentional styling (color emphasis,
     bolding) survive untouched. */
  desc.querySelectorAll('[style]').forEach(function (el) {
    el.style.removeProperty('font-size');
    el.style.removeProperty('font-family');
    if (!el.getAttribute('style')) el.removeAttribute('style');
  });

  /* Bold-only paragraphs are headings in disguise. */
  desc.querySelectorAll(':scope > p').forEach(function (p) {
    var strong = p.children.length === 1 && p.children[0].tagName === 'STRONG' ? p.children[0] : null;
    if (!strong) return;
    var text = strong.textContent.trim();
    if (!text || text.length > 60) return;
    if (p.textContent.trim() !== text) return;
    var h = document.createElement('h4');
    h.textContent = text;
    p.replaceWith(h);
  });

  /* Wrap each heading and everything after it into a section. Nodes before
     the first heading stay put as the intro. */
  var nodes = Array.prototype.slice.call(desc.childNodes);
  var section = null;
  nodes.forEach(function (node) {
    var isHeading = node.nodeType === 1 && /^H[2-4]$/.test(node.tagName);
    if (isHeading) {
      section = document.createElement('div');
      section.className = 'pdesc-section';
      if (/ship|deliver|warrant|return|lead time|specification/.test(node.textContent.toLowerCase())) {
        section.className += ' pdesc-section--specs';
      }
      desc.insertBefore(section, node);
      node.classList.add('pdesc-heading');
      section.appendChild(node);
    } else if (section) {
      section.appendChild(node);
    }
  });
})();
